export const en = {
    hello: "Hello",
    User_log_in: "User log in",
    Access_key: "Access key",
    Public_Mode_1: "Public Mode",
    Public_Mode_2:
    "This mode provides the full functionality of the configurator. Projects can be created, saved and Production Files can be downloaded. But all projects can be seen, edited and deleted by anybody using the public mode. No Access Key is required.",
    Private_Workspace_1: "Private Workspace",
    Private_Workspace_2:
    "Projects can be created and saved and Production Files can be downloaded. All projects can be seen, edited and deleted only by the user of the Access Key. In order to request a free Access Key, please register via T4Tsupport@inventronicsglobal.com. One organization shall share one workspace.",
    Help: "Help",
    Log_In: "Log In",
    Signed_in_as: "Signed in as",
    Version: "Version",
    Luminaire_Configurator: "Luminaire Configurator",
    Create_New_Project: "Create New Project",
    Open_file: "Open file",
    from_computer: "from computer",
    Open_project: "Open project",
    from_cloud: "from cloud",
    Recent_Projects: "Recent Projects",
    Status: "Status",
    Project_Name: "Project Name",
    Update_Date: "Update Date",
    Select_Device: "Select Device",
    SHOW_ALL: "SHOW ALL",
    INDOOR_ONLY: "INDOOR ONLY",
    OUTDOOR_ONLY: "OUTDOOR ONLY",
    Advanced_filters: "Advanced filters",
    Programming_Interface: "Programming Interface",
    Show_only_newest_FW_versions: "Show only newest FW versions",
    Show_only_favourites: "Show only favourites",
    Driver: "Driver",
    Summary: "Summary",
    Operating_Mode: "Operating Mode",
    Current_Mode: "Current Mode",
    Fixed_Current: "Fixed Current",
    Minimum_Current: "Minimum Current",
    Operating_Current: "Operating Current",
    Maximum_Current: "Maximum Current",
    Good_Performance_Area: "Good Performance Area",
    Programmed_Operating_Area: "Programmed Operating Area",
    Allowed_Operating_Area: "Allowed Operating Area",
    Current_graph: "Current [mA]",
    Voltage_graph: "Voltage [V]",
    Adjustable_Dim: "Adjustable Dim",
    Dim_to_Off: "Dim-to-Off",
    Airborne: "Floating",
    Typical_curves: "Typical curves",
    Graph: "Graph",
    Enable_Disable_DimOnOff: "Enable / Disable DimOnOff",
    Constant_Lumen: "Constant Lumen",
    Levels_Times: "Levels and Times",
    Energy_Saving_Potential: "Energy Saving Potential",
    End_Life: "End of Life",
    Power_Settings: "Power Settings",
    Driver_Guard: "Driver Guard",
    Thermal_Settings: "Thermal Settings",
    PWM_Dim: "PWM Dim",
    Submode: "Submode",
    Astro_Based: "Astro Based",
    RTC_Based: "RTC Based",
    Time_Based: "Time Based",
    SD_triggered: "SD triggered",
    Fade_Timing: "Fade Timing",
    Switch_On_Fade_Time: "Switch On Fade Time",
    AstroDIM_Fade_Time: "AstroDIM Fade Time",
    Switch_Off_Fade_Time: "Switch Off Fade Time",
    Location: "Location",
    Reference_Schedule: "Reference Schedule",
    Preset_Profiles: "Preset Profiles",
    Energy_Savings: "Energy Savings",
    Loaded_Data: "Loaded Data",
    Loaded_Data_Info: "This project was loaded from a device readback. Changing the submode replaces the schedule with default values; this restores every setting on this page to the values read from the driver.",
    Reset_To_Loaded_Data: "Reset to loaded data",
    Output_Level: "Output Level",
    Time: "Time",
    Custom: "Custom",
    Positive: "Positive",
    Negative: "Negative",
    Dimming: "Dimming",
    Operating_Time: "Operating Time",
    Cons_Lum_Eng_Savings: "Data does not allow calculating a saving potential",
    Up_to: "Up to",
    energy_saving_in: "energy saving in",
    More_info: "More info",
    Less_info: "Less info",
    Warning: "Warning",
    Are_you_sure_remove_driver: "Are you sure that you want to remove the driver",
    from_the_project: "from the project?",
    Yes: "Yes",
    No: "No",
    Delete_driver: "Delete driver",
    Order_code: "Order code",
    Basic_Code: "Basic Code",
    Description: "Description",
    Customer_Project: "Customer/Project",
    numberOfDevices: "# of devices",
    Serial_Number: "Serial Number",
    FW_Version: "FW Version",
    Driver_Count: "Driver Count",
    Change_Image: "Change Image",
    Datasheet: "Datasheet",
    Maximum_Output_Current: "Maximum Output Current",
    Minimum_Output_Current: "Minimum Output Current",
    Slow: "Slow",
    FixedCurrent: "FixedCurrent",
    Latitude: "Latitude",
    Longitude: "Longitude",
    Time_Zone: "Time Zone",
    MidNight_Shift: "MidNight Shift",
    Save_as: "Save as",
    Rename: "Rename",
    Saving: "Saving",
    Change_project_name: "Change project name",
    Download: "Download",
    Downloading: "Downloading",
    Finish_and_download: "Finish and download",
    Consistent_with_the_dimming_logic: "Consistent with the dimming logic",
    Temperature: "Temperature",
    Linear: "Linear",
    Logarithmic: "Logarithmic",
    // am58968 spells the dd-file enum label lowercase
    logarithmic: "Logarithmic",
    Fade: "Fade",
    Extended_Fade_Time: "Extended Fade Time",
    Fade_Time: "Fade Time",
    Fade_Rate: "Fade Rate",
    Limits: "Limits",
    Min_Level: "Min Level",
    Max_Level: "Max Level",
    Level: "Level",
    Use_last_stored_level_on_Power_ON: "Use last stored level on Power ON",
    Dont_change_existing_level_on_System_Failure: "Don't change existing level on System Failure",
    Address: "Address",
    Groups: "Groups",
    Scenes: "Scenes",
    Dali_Addressing: "Dali Addressing",
    Dexal_Power_Supply_Unit: "Dexal Power Supply Unit",
    Supply_On_Mains_Off: "Mains Off",
    Maintain_Supply: "Maintain Supply",
    Maintain_Supply_Subtitle: "(slow turn off)",
    Immediate_Off: "Immediate Off",
    Parameters: "Parameters",
    Identification_Number: "Identification Number",
    GTIN: "GTIN",
    General: "General",
    Content_Format_ID: "Content Format ID",
    Use_programming_date: "Use programming date",
    Year: "Year",
    Week: "Week",
    Light_Distribution: "Light Distribution",
    Light_distribution_type: "Light distribution type",
    Generate_unique_number_per_driver: "Generate unique number per driver",
    Additional_luminaire_information: "Additional luminaire information",
    max: "max",
    chars: "chars",
    Luminaire_color: "Luminaire color",
    Rated_Median_Useful_Life_of_Luminaire: "Rated Median Useful Life of Luminaire (tq=25°C)",
    Internal_Control_Gear_Reference_Temperature: "Internal Control Gear Reference Temperature (tq=25°C)",
    Rated_Median_Useful_Light_Source_Starts: "Rated Median Useful Light Source Starts",
    NominalInputPower: "Nominal Input Power",
    PowerAtMinimumDimLevel: "Power At Minimum Dim Level",
    NominalMinimumACMainsVoltage: "Nominal Minimum A C Mains Voltage",
    NominalMaximumACMainsVoltage: "Nominal Maximum A C Mains Voltage",
    NominalLightOutput: "Nominal Light Output",
    ColorRenderingIndex: "Color Rendering Index",
    CorrelatedColorTemperature: "Correlated Color Temperature",
    OEMName: "O E M Name",
    StockingNumber: "Stocking Number",
    LampCurrent: "Lamp Current",
    CustomerUse: "Customer Use",
    Configuration_Lock: "Configuration Lock",
    Access_to_Features: "Access to Features",
    Everyone: "Everyone",
    Operating_Modes: "Operating Modes",
    End_of_Life: "End of Life",
    Dimming_Levels: "Dimming Levels",
    Luminaire_Info_and_DEXAL_PSU: "Luminaire Info and DEXAL PSU",
    Select_all: "Select all",
    Cancel: "Cancel",
    Select: "Select",
    Selection: "Selection",
    New_Project_name: "New Project name",
    Save: "Save",
    You_have_not_set_up_a_password_line_1: "You have not set up a password protection for this luminaire configuration.",
    You_have_not_set_up_a_password_line_2:
    "We strongly advise to set up a password to avoid unintentional or unauthorized adjustment of crucial paramenters that might lead to damage or non-safe operation of the luminaire.",
    You_have_not_set_up_a_password_line_3:
    "Please also consider the required luminaire certifications and the effect of parameter adjustments on the validity of such certifications.",
    Continue_anyways: "Continue anyways",
    Programming_Options: "Programming Options",
    Program_As: "Program As",
    Master: "Master",
    Service: "Service",
    User: "User",
    If_target_driver_is_protected: "If target driver is protected, use the following PW to unlock for programming:",
    key: "key",
    master: "master",
    Verify_parameters_after_programming: "Verify parameters after programming",
    Disable_Family_Programming: "Disable Family Programming",

    Luminaire_Info: "Luminaire Info",
    Emergency_Mode: "Emergency Mode",
    Tuning_Factor__Level: "Tuning Factor: Level",
    Tuning_Factor__Limits___Lumen: "Tuning Factor: Limits / Lumen",
    Dim_to_Dark: "Dim to Dark",
    Soft_Switch_Off: "Soft Switch Off",
    Soft_Start: "Soft Start",
    Power_On_Level: "Power On Level",
    Loss_Dim_Data: "Loss Dim Data",
    Enable_Disable: "Enable / Disable",

    Off_Low: "Off/Low",
    On_High: "On/High",
    Detect: "Detect",
    Pull_Up_Current_Selection: "Dimming line current source",
    Auxiliary_Voltage_Selection: "Auxiliary Voltage Selection",
    Input_Voltage: "Input Voltage",
    Protection: "Protection",
    Recovery: "Recovery",
    Under_Voltage: "Under Voltage",
    Over_Voltage: "Over Voltage",

    Operation_Mode_Not_Programmed: "Please note, that Operation Mode will not be programmed!",
    Driver_Compatibility_Warning:
    "Please be aware, that T4T will not verify driver compatibility with selected LED module.",
    Unsaved_Project_Warning:
    "You have not filled in all the required fields, your project will be deleted. Are you sure you want to leave?",
    Imprint: "Imprint",
    Terms_of_Use: "Terms of Use",
    Privacy_Policy: "Privacy Policy",
    Open_Source_Licenses: "Open Source Licenses",
    Contacts: "Contacts",
    Logging_in: "Logging in",
    Tuner4TRONIC: "Tuner4TRONIC",
    Access_Key_Error: "Please insert a correct Access Key or try public mode",
    Leave_This_Page: "Leave This Page",
    Confirmation: "Confirmation",
    Logout_Access_Key_Warning:
    "Please be aware that the access key to access your private workspace will be deleted from your browser if you proceed logging out",
    Continue: "Continue",
    Ok: "Ok",
    Error: "Error",
    Projects: "Projects",
    Delete_Project_Confirmation: "Are you sure that you want to delete the project?",
    Filter: "Filter",
    Filter_by_interface: "Filter by interface",
    Filter_by_ECG_type: "Filter by ECG type",
    All: "All",
    Errors: "Errors",
    Warnings: "Warnings",
    Thermal_Protection: "Thermal Protection",
    FR_Arrete_nuisances_lumineuses: "FR – Arrêté nuisances lumineuses",
    FR_Warning_Profile:
    'Warning: This predefined profile fulfills the requirements of French law "Arrêté nuisances lumineuses" regarding a project located in city of Paris and switched ON/OFF at sunset and sunrise with an average mid-point of the night around 00h45. Values have to be adjusted depending on your project characteristics. Inventronics cannot be responsible in case of misuse. First power-on cycle only for calibration.',
    Mask_CH1: "Mask CH1",
    Mask_CH2: "Mask CH2",
    Mask_CH3: "Mask CH3",
    Mask_CH4: "Mask CH4",
    Partial: "Partial",
    Locked_Features: "Locked Feature(s)",
    Power_On_Behaviour: "Power On Behaviour",
    Light_Controls: "Light Controls",
    Switch_ON_OFF_Short_Push: "Switch ON/OFF (Short Push)",
    Dim_UP_DOWN_Long_Push: "Dim UP/DOWN (Long Push)",
    Set_Reset_level_Double_Push: "Set/Reset level (Double Push)",
    Mains_Frequency: "Mains Frequency",
    Operative: "Operative",
    Fade_Time_1: "Fade Time [1]",
    Operative_Level: "PD Level",
    Hold_Time_2: "Hold Time [2]",
    Fade_Time_3: "Fade Time [3]",
    DALI_Level: "DALI Level",
    Hold_Time_4: "Hold Time [4]",
    Fade_Time_5: "Fade Time [5]",
    Hold_Time_6: "Hold Time [6]",
    Fixed_Current_CH2: "Fixed Current CH2",
    Luminous_Flux: "Luminous Flux",
    Tuning_Factor: "Tuning Factor",
    Limits_and_Reference_Lumen: "Limits and Reference Lumen",
    Tuning_Level: "Tuning Level",
    Colour_Temperature: "Colour Temperature",
    Use_last_stored_colour_temperature: "Use last stored colour temperature on Power ON",
    LED_Module_Configuration: "LED Module Configuration",
    Physical_Coldest: "Physical Coldest",
    Physical_Warmest: "Physical Warmest",
    Colour_Temperature_Range: "Colour Temperature Range",
    Coldest: "Coldest",
    Warmest: "Warmest",
    Dim_Settings: "Dim Settings",
    Dim_To_Dark: "Dim To Dark",
    Settings: "Settings",
    Architectural_Features: "Architectural Features",
    Low_Level_Dimming_Mode: "Low-Level Dimming Mode",
    Dimming_Mode: "Dimming Mode",
    Max_Power: "Max Power",
    DC_Mains_Emergency_Mode: "DC Mains -> Emergency Mode",
    Close: "Close",
    Load_LED_Module: "Load LED Module",
    Ambient: "Ambient",
    Modularity_serial: "Modularity (serial)",
    Count: "Count",
    Cold_White_CH1: "Cold White CH1",
    Module_Temperature: "Module Temperature",
    Color_X: "Color X",
    Color_Y: "Color Y",
    Color_Temperature: "Color Temperature",
    Warm_White_CH2: "Warm White CH2",
    Maximum_nominal_input_power: "Maximum nominal input power",
    Initial_luminous_flux: "Initial luminous flux",
    Correlated_color_temperature: "Correlated color temperature",
    Color_rendering_index: "Color rendering index",
    Start_Level: "Start Level",
    Channel_1: "Channel 1",
    Channel_2: "Channel 2",
    Permanent_Shut_Down: "Permanent Shut Down",
    Power_On_Delay: "DALI Power-On Delay",
    Custom_Power_On_Delay: "Custom Power-On Delay",
    Output_Levels: "Output Levels",
    Keep_Astro_Dim_color: "Keep Astro Dim color",
    PD_Timing: "PD Timing",
    PD_Sensor_type_label: "Presence detection sensor type",
    PWM_Dimming_Mode: "PWM Dimming Mode",
    Mode: "Mode",
    Normalized: "Normalized",
    Extended: "Extended",
    Repeater: "Repeater",
    Mode_Settings: "Mode Settings",
    Phys_Min_level: "Phys Min level",
    Min_Level_Auto_Detection: "Min Level Auto Detection",
    Nominal_Level: "Nominal Level",
    SD_Level: "SD Level",
    Switch_On_Timing: "Switch On Timing",
    SD_Timing: "SD Timing",
    Sensor_Type: "Sensor Type",
    Resistor_Based: "Resistor Based",
    Temperature_Based: "Temperature Based",
    Start_Derating: "Start Derating",
    End_Derating: "End Derating",
    Shut_Off: "Shut Off",
    Derating_Level: "Derating Level",
    Light_Level_Control_Button_1: "Light Level Control (Button 1)",
    Power_ON_settings: "Power ON settings",
    Operative_settings: "Presence Detection settings",
    Fade_Time_4: "Fade Time [4]",
    Hold_Time_5: "Hold Time [5]",
    Sensors: "Sensors",
    Light_sensor: "Light sensor",
    Presence_detection: "Presence detection",
    Holiday_Mode: "Holiday Mode",
    Auto_disable_Presence_Detection: "Auto disable Presence Detection",
    Set_Luminaire_reference_light_output: "Set Luminaire reference light output at 100%",
    Lumen: "Lumen",
    Setting: "Setting",
    Min_DIM_Level: "Min DIM Level",
    Feature: "Feature",
    Parameter: "Parameter",
    Value: "Value",
    Unit: "Unit",
    PROJECT_WITHOUT_DRIVERS: "PROJECT WITHOUT DRIVERS",
    Stay: "Stay",
    Leave: "Leave",
    Fixed_Current_CH1: "Fixed Current CH1",
    Use_this_functionality_to_limit_Light_Output:
    "Use this functionality to limit the Light Output using the T4T Field App. Don't forget to update the access rights with the Configuration Lock",
    Select_LED_Module: "Select LED Module",
    D2W_Note:
    "Color temperature values with respect to physical warmest/coldest temperature.\nNote: Programming D2W mode with DALI interface will not update physical warmest/coldest settings.",
    Dimming_Level: "Dimming Level",
    Color: "Color",
    Output_Level_Percent: "Output Level (%)",
    Time_h: "Time (h)",
    Time_Elapsed_h: "Time elapsed since start (h)",
    Midnight: "Midnight",
    StandBy: "StandBy",
    Maximum_Limit: "Maximum Limit",
    Minimum_Limit: "Minimum Limit",
    Set_Luminaire_Reference: "Set Luminaire reference light output at 100%",
    Only_Master: "Only Master",
    Service_and_Master: "Service and Master",
    Dont_change_colour_on_System_Failure: "Don't change existing colour Temperature on System Failure",
    Use_last_stored_colour_temperature_on_Power_ON: "Use last stored colour temperature on Power ON",

    Clear_all: "Clear all",
    Products_News: "Products News",
    Read_more: "Read more",
    Tunable_White_LED_Module_Configurator: "Tunable White LED Module Configurator",
    Create_New_Module: "Create New Module",
    Open_Module: "Open Module",
    Frontend_version: "Frontend version:",
    Customer: "Customer",
    Creation_Date: "Creation Date",
    Saving_as_new: "Saving as new",
    Download_API_Key_Warning: "The download of production file is only available for users with API KEY",
    Project_name_placeholder: "Project name",
    Download_Not_Available_Warning: "The download of production file is not available in Public Mode",
    Public_Mode_Privacy_Warning: "As a privacy measure in Public Mode, the file will not be saved in the cloud",
    Project_saved: "Project saved",
    Properties_to_update: "propert(y/ies) to update",
    Open_in_P4: "Open in P4",
    Adding_Driver: "Adding Driver",
    Please_select_Device_Before: "Please select Device Before",
    Please_select_Device: "Please select Device",
    Looks_good: "Looks good!",
    Released_OSRAM_LED_modules: "Released LED modules",
    Customer_LED_modules_removable: "Customer LED modules (removable)",
    Loading: "Loading",
    Modularity_Reset_Warning: "Changing modularity will reset current settings to default",
    Tdriver_max: "Tdriver max",
    StandBy_1: "StandBy 1",
    StandBy_2: "StandBy 2",
    Project_Not_Found_Message: "We are sorry but the project: '{{url}}' is not available (for this user).",
    Project_May_Have_Been_Deleted: "The project may have been deleted.",
    Light_Level_Control_Button_2: "Light Level Control (Button 2)",
    CCT_Control_Button_2: "CCT Control (Button 2)",
    Set_Colour_to_middle_Short_Push: "Set Colour to middle (Short Push)",
    Colour_WARMER_COLDER_Long_Push: "Colour WARMER/COLDER (Long Push)",
    Set_Reset_Colour_Double_Push: "Set/Reset Colour (Double Push)",
    Start_with_active_level: "Start with active level before last Power OFF",
    Start_with_active_color: "Start with active color temperature before last Power OFF",
    Mains_Power_ON_Level_CH1: "Mains Power ON Level CH 1",
    Mains_Power_ON_DALI_Level: "Mains Power ON DALI light Level",
    Mains_Power_ON_Level_CH2: "Mains Power ON DALI light Level CH2",
    Mains_Power_ON_Colour: "Mains Power ON Colour",
    Use_active_level_before_Switch_OFF: "Use active level before last Switch OFF",
    Use_active_CCT_before_Switch_OFF: "Use active CCT before last Switch OFF",
    Kelvin: "Kelvin",
    Colour: "Colour",
    Mirek: "Mirek",
    the_project: "the project",
    Download_API_Key_Warning_Full:
    "The download of production file is a functionality available only having an API-KEY. Please contact your Inventronics sales representative for more information.",
    Download_Errors_Warning:
    "The download of production file is not available since there are some errors. Please fix them and then retry.",
    Public_Mode_Project_Deleted:
    "As a privacy measure in Public Mode, your project was downloaded to your PC but deleted from the cloud.",
    Premium_Functionality_Text:
    "{{featureName}} is a premium functionality. You can create a configuration file using this feature but when programming the drivers, a fee per device will incur.",
    Contact_Sales_Representative: "Please contact your Inventronics sales representative for more information.",
    power_on_delay_value: "Value",
    anti_flicker: "Anti Flicker",
    pull_up_current_warning: "WARNING: MULT-PRG2 cannot communicate with the driver. If programming is required, a 20K-50K resistor must be added between VCC and DIM+",
    AstroDim_Override_Info: "This schedule will be temporarily overridden when a 0-10V signal is detected. Once removed, the driver switches back to the AstroDim schedule.",
    // --- MPPT solar charge controller (am58962) -----------------------------------------
    // Keys are the fea display name / enum label with spaces replaced by underscores; see
    // SolarChargeController.label() and tr(). Keys starting with a digit must be quoted.
    Battery_Type: "Battery Type",
    System_Voltage: "System Voltage",
    "12V_Over_Discharge_Voltage": "12V Over Discharge Voltage",
    "12V_Over_Discharge_Return_Voltage": "12V Over Discharge Return Voltage",
    "12V_Charge_Voltage": "12V Charge Voltage",
    "12V_Charge_Return_Voltage": "12V Charge Return Voltage",
    "12V_Boost_Charge_Voltage": "12V Boost Charge Voltage",
    "12V_Floating_Charge_Voltage": "12V Floating Charge Voltage",
    Maximum_Battery_Charging_Current: "Maximum Battery Charging Current",
    "24V_Over_Discharge_Voltage": "24V Over Discharge Voltage",
    "24V_Over_Discharge_Return_Voltage": "24V Over Discharge Return Voltage",
    "24V_Charge_Voltage": "24V Charge Voltage",
    "24V_Charge_Return_Voltage": "24V Charge Return Voltage",
    "24V_Boost_Charge_Voltage": "24V Boost Charge Voltage",
    "24V_Floating_Charge_Voltage": "24V Floating Charge Voltage",
    Sleep_Mode: "Sleep Mode",
    Light_Control_Voltage: "Light Control Voltage",
    Light_Control_Delay: "Light Control Delay",
    Temperature_Protection_Mode: "Temperature Protection Mode",
    "T1_for_Charging_stop_(H)": "T1 for Charging stop (H)",
    "T2_for_Charging_stop_(L)": "T2 for Charging stop (L)",
    "T3_for_Discharging_stop_(H)": "T3 for Discharging stop (H)",
    "T4_for_Discharging_stop_(L)": "T4 for Discharging stop (L)",
    "T5_for_Charging_Limit_(H)": "T5 for Charging Limit (H)",
    "T6_for_Charging_Limit_(L)": "T6 for Charging Limit (L)",
    "T7_for_Discharging_Limit_(H)": "T7 for Discharging Limit (H)",
    "T8_for_Discharging_Limit_(L)": "T8 for Discharging Limit (L)",
    Charge_Limit_Current_1: "Charge Limit Current 1",
    Charge_Limit_Current_2: "Charge Limit Current 2",
    Discharge_Limit_Current_1: "Discharge Limit Current 1",
    Discharge_Limit_Current_2: "Discharge Limit Current 2",
    Output_Derating_Current: "Output Derating Current",
    Recovery_Temperature: "Recovery Temperature",
    Protection_Temperature: "Protection Temperature",
    Intelligent_Output_Adjustment: "Intelligent Output Adjustment",
    Derating_Start_Voltage: "Derating Start Voltage",
    Derating_End_Voltage: "Derating End Voltage",
    Derating_End_Current: "Derating End Current",
    Lighting_Mode: "Lighting Mode",
    Sunrise_Time: "Sunrise Time",
    Sunset_Time: "Sunset Time",
    Enable_Daylight_Saving_Time: "Enable Daylight Saving Time",
    "Region/Time_Zone": "Region/Time Zone",
    Battery_Lead_Resistance_Compensation: "Battery Lead Resistance Compensation",
    // Time_Zone and User are already defined above and serve here too.
    // enum values - frontend only, the api does not localize AvailableValues
    "Lead-acid": "Lead-acid",
    LiFePO: "LiFePO",
    Auto: "Auto",
    "12V": "12V",
    "24V": "24V",
    "Auto-12V": "Auto-12V",
    "Auto-24V": "Auto-24V",
    Battery: "Battery",
    LEDs: "LEDs",
    High: "High",
    Middle: "Middle",
    Low: "Low",
    OFF: "OFF",
    PV_Priority: "PV Priority",
    RTC_Time_Priority: "RTC Time Priority",
    Both_PV_and_RTC_Time: "Both PV and RTC Time",
};
